import bootstarp from '../Assets/bootstarp.png'
import react from '../Assets/react.png'
import nest from '../Assets/nest.png'
import css from '../Assets/csspng.png'
import cs50 from '../Assets/cs50.png'
import htmlC from '../Assets/htmlC.png'
import node from '../Assets/node.jpg'
import js from '../Assets/javascript.png'

export const data = [
    [{
        id: Math.random(),
        title: "The Complete HTML course for Beginners from zero to hero",
        category: "Front-end",
        hours: "3h",
        lessons: "28 Lesson",
        img: htmlC
    },
    {
        id: Math.random(),
        title: "The Complete Node Js course for Beginners from zero to hero",
        category: "Back-end",
        hours: "33h",
        lessons: "227 Lesson",
        img: node
    },
    {
        id: Math.random(),
        title: "The Complete JavaScript course from zero to hero",
        category: "Front-end",
        hours: "15h",
        lessons: "80 Lesson",
        img: js
    },
    {
        id: Math.random(),
        title: "The Complete Bootstrap course for Beginners",
        category: "Front-end",
        hours: "3h",
        lessons: "26 Lessons",
        img: bootstarp
    }, {
        id: Math.random(),
        title: "The Complete React Js course for Beginners from zero to hero",
        category: "Front-end",
        hours: "10h 20m",
        lessons: "110 Lesson",
        img: react
    },
    {
        id: Math.random(),
        title: "The Complete Nest Js course for Beginners from zero to hero",
        category: "Back-end",
        hours: "22h",
        lessons: "142 Lesson",
        img: nest
    },
    {
        id: Math.random(),
        title: "The Complete CSS course for Beginners from zero to hero",
        category: "Front-end",
        hours: "8h",
        lessons: "52 Lesson",
        img: css
    },
    {
        id: Math.random(),
        title: "The Complete CS50 course form Scratch for Beginners",
        category: "CS",
        hours: "10h",
        lessons: "82 Lesson",
        img: cs50
    }],
    [
        {
            id: Math.random(),
            title: "HTML",
            info: "To start your career in the Web field, you need to learn the language of web page design, which is essential whether you are a designer or a developer. This language is HTML, and you will find the educational course along with all the references you need, as well as exercises and many ideas.",
            icon: "fa-brands fa-html5 icon",

        },
        {
            id: Math.random(),
            title: "CSS",
            info: "It is used to style and layout web pages. With CSS, you can control the color, font, size, spacing, and various other design elements on your web page. CSS allows users to separate the layout and design from the HTML structure, making it easier to change the appearance of web pages consistently.",
            icon: "fa-brands fa-css3-alt icon",

        },
        {
            id: Math.random(),
            title: "BootStrap",
            info: "Bootstrap is the most famous framework for website design, as many programmers use it to design their websites because it saves a lot of effort and trouble, as website development in its modern form no longer requires rewriting every movement and every element of the website pages, and organizing the page has become a simple matter.",
            icon: "fa-brands fa-bootstrap icon",

        },
        {
            id: Math.random(),
            title: "JavaScript",
            info: "It is considered your most important step in Front End, and it is considered the first programming language you will deal with. You must be familiar with  ( Basics - DOM - BOM - OOP - API )",
            icon: "fa-brands fa-js icon"
        },
        {
            id: Math.random(),
            title: "JS Framework",
            info: "To make it easier for you and to provide the best experience in the shortest time, you should use a JavaScript framework. You can choose between many of them, Such as ( Vue.js - React.js - Angular.js )",
            icon: "fa-solid fa-users-rectangle icon"
        },

    ],
    [
        {
            id: Math.random(),
            title: "Programming basics",
            info: "You must be familiar with the basics of programming before starting to learn any programming language.",
            icon: "fa-regular fa-file-code icon",
        },
        {
            id: Math.random(),
            title: "JavaScript Basics",
            info: "Learn the basics of JavaScript, such as Data Types - Conditions - Loops - Functions.",
            icon: "fa-brands fa-square-js icon",
        },
        {
            id: Math.random(),
            title: "DOM",
            info: "It represents the structure of a web page as a tree of objects. It allows developers to interact with the content, structure, and style of a webpage dynamically.",
            icon: "fa-solid fa-sitemap icon",
        },
        {
            id: Math.random(),
            title: "BOM",
            info: "Learn how to control the browser and all its features by learning the BOM.",
            icon: "fa-regular fa-folder-open icon",
        },
        {
            id: Math.random(),
            title: "OOP",
            info: "Method of writing code that allows you to create objects that have properties and functions. This method is considered one of the most important programming methods in general, not only in JavaScript, but learning it in JavaScript opens you up to many fields.",
            icon: "fa-solid fa-code icon",
        },
        {
            id: Math.random(),
            title: "ES6",
            info: "You must be fully aware of all the developments that have occurred in ECMAScript 6 because after this development it has become impossible to do without the features that have been added.",
            icon: "fa-solid fa-e icon",
        },
        {
            id: Math.random(),
            title: "AJAX & JSON",
            info: "Learning AJAX and JSON will make you able to deal with APIs, and this is one of the most important steps in your path.",
            icon: "fa-regular fa-file-code icon",
        },
        {
            id: Math.random(),
            title: "JS Framework",
            info: "To make it easier for you and to provide the best experience in the shortest time, you should use a JavaScript framework. You can choose between many of them, Such as ( Vue.js - React.js - Angular.js ).",
            icon: "fa-solid fa-users-rectangle icon",
        },

    ],
    [
        {
            id: Math.random(),
            title: "Programming Language",
            info: "In this step, you can choose any programming language that supports working with the web, and there are many examples nodeJs - DotNet.",
            icon: "fa-solid fa-code icon"
        },
        {
            id: Math.random(),
            title: "Framework",
            info: "After choosing the programming language that you will work with in Backend, the next step for you is to choose a work environment to make it easier for you and provide the best code in the shortest possible time. Every programming language has the appropriate work environment, so if you choose PHP, the appropriate work environment is Laravel.",
            icon: "fa-brands fa-laravel icon"
        },
        {
            id: Math.random(),
            title: "My SQL",
            info: "After learning all this, you must now deal with databases to save your project data in. MySQL databases are among the most famous databases in the world of the web, and they are responsible for dealing with the database of your application or project and sending and receiving data from it.",
            icon: "fa-solid fa-database icon"
        },
        {
            id: Math.random(),
            title: "Publish your site",
            info: "After you have completed the website, you must now publish it on the World Wide Web so that all users can see it. To make the website files visible to the public, you must upload them to a hosting and link the hosting to a domain such as www.EDUTRAX.net, for example. ",
            icon: "fa-solid fa-upload icon"
        },
    ],
    [
        {
            id: Math.random(),
            header: "Full Stack",
            desc: 'If you want to become a strong Full Stack, you must follow this map in order.',
            title: "Programming Language",
            info: "In this step, you can choose any programming language that supports working with the web, and there are many examples nodeJs - DotNet.",
            icon: "fa-solid fa-code icon"
        },
        {
            id: Math.random(),
            title: "UI/UX",
            info: "Learning UI UX will make you able to provide the best user experience in terms of design.",
            icon: "fa-brands fa-figma icon"

        },
        {
            id: Math.random(),
            title: "HTML",
            info: "To start your career in the Web field, you need to learn the language of web page design, which is essential whether you are a designer or a developer. This language is HTML, and you will find the educational course along with all the references you need, as well as exercises and many ideas.",
            icon: "fa-brands fa-html5 icon",

        },
        {
            id: Math.random(),
            title: "CSS",
            info: "It is used to style and layout web pages. With CSS, you can control the color, font, size, spacing, and various other design elements on your web page. CSS allows users to separate the layout and design from the HTML structure, making it easier to change the appearance of web pages consistently.",
            icon: "fa-brands fa-css3-alt icon",

        },
        {
            id: Math.random(),
            title: "BootStrap",
            info: "Bootstrap is the most famous framework for website design, as many programmers use it to design their websites because it saves a lot of effort and trouble, as website development in its modern form no longer requires rewriting every movement and every element of the website pages, and organizing the page has become a simple matter.",
            icon: "fa-brands fa-bootstrap icon",

        },
        {
            id: Math.random(),
            title: "JavaScript",
            info: "It is considered your most important step in Front End, and it is considered the first programming language you will deal with. You must be familiar with  ( Basics - DOM - BOM - OOP - API )",
            icon: "fa-brands fa-js icon"
        },
        {
            id: Math.random(),
            title: "JS Framework",
            info: "To make it easier for you and to provide the best experience in the shortest time, you should use a JavaScript framework. You can choose between many of them, Such as ( Vue.js - React.js - Angular.js )",
            icon: "fa-solid fa-users-rectangle icon"
        },
        {
            id: Math.random(),
            title: "Framework",
            info: "After choosing the programming language that you will work with in Backend, the next step for you is to choose a work environment to make it easier for you and provide the best code in the shortest possible time. Every programming language has the appropriate work environment, so if you choose PHP, the appropriate work environment is Laravel.",
            icon: "fa-brands fa-laravel icon"
        },
        {
            id: Math.random(),
            title: "My SQL",
            info: "After learning all this, you must now deal with databases to save your project data in. MySQL databases are among the most famous databases in the world of the web, and they are responsible for dealing with the database of your application or project and sending and receiving data from it.",
            icon: "fa-solid fa-database icon"

        },
        {
            id: Math.random(),
            title: "Publish your site",
            info: "After you have completed the website, you must now publish it on the World Wide Web so that all users can see it. To make the website files visible to the public, you must upload them to a hosting and link the hosting to a domain such as www.EDUTRAX.net, for example. ",
            icon: "fa-solid fa-upload icon"
        }
    ],
    [
        {
            id: Math.random(),
            title: "Programming",
            info: "You must learn many programming languages, but do not worry, you do not have to master them all. It is enough to know how to write each language The Python language is one of the most important programming languages in demand in this field But the advice of mastering several programming languages will allow you to excel in the field of cybersecurity. ",
            icon: "fa-solid fa-code icon"
        },
        {
            id: Math.random(),
            title: "Networking ",
            info: "Learning about networks is one of the most weak points in any system and is considered one of the most important things that a cybersecurity specialist must know, as most electronic attacks occur through different networks. ",
            icon: "fa-solid fa-network-wired icon"

        },
        {
            id: Math.random(),
            title: "Operation Systems",
            info: "Operating systems like Windows, Linux, Android, etc. are responsible for regulating hardware functions, so they are the first to be hacked ,Your task is to ensure that the private devices in the system you are protecting do not get hacked, in addition to knowing how to secure it and the operating systems it uses against any attacks.You should know that Linux is one of the most important systems to learn, because it contains a lot of important and useful software in this field, and it is more difficult to hack than other operating systems.",
            icon: "fa-brands fa-windows icon"
        },
        {
            id: Math.random(),
            title: "IT",
            info: "Information Technology is one of the most important skills that must be learned in the field of cybersecurity.. ",
            icon: "fa-solid fa-users-gear icon"
        },
        {
            id: Math.random(),
            title: "Computer Science",
            info: "Computer science is indispensable whether for learning cybersecurity or other technical fields, as it is essential for understanding how things are done. ",
            icon: "fa-solid fa-laptop-code icon"
        },

    ]


]
